module.exports = __webpack_public_path__ + "static/media/lachaert.2a7c5ed3.jpg";